module.exports = __webpack_public_path__ + "static/busloclogo-ff74d72d168639c98ac76d19b9014236.png";